module.exports = __webpack_public_path__ + "4c1e6e233adcb8d407ab4e2993b809b5.pdf";